import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Loading from '../components/common/Loading';
import ErrorBoundary from '../components/common/ErrorBoundary';
import DevQaTriggers from '../components/common/DevQaTriggers';
import SessionGate from './SessionGate';
import PublicRoute from './publicsRoutes';
import LandingRoute from './landingRoute';
import RouteCatchAll from './RouteCatchAll';
import {
  Landing,
  Login,
  Register,
  ForgotPassword,
  ResetPassword,
  VerifyEmail,
  ActivateAccount,
  SubscribeCheckout,
  ChoosePlan,
  SelectPlan,
} from './lazyComponents';

const RoutesApp: React.FC = () => (
  <Router future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
    <ErrorBoundary>
      <DevQaTriggers />
      <SessionGate>
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route path="/" element={<LandingRoute element={<Landing />} />} />
            <Route path="/login" element={<PublicRoute element={<Login />} />} />
            <Route path="/register" element={<PublicRoute element={<Register />} />} />
            <Route path="/forgot-password" element={<PublicRoute element={<ForgotPassword />} />} />
            <Route path="/reset-password" element={<PublicRoute element={<ResetPassword />} />} />
            <Route path="/verificar-email" element={<PublicRoute element={<VerifyEmail />} />} />
            <Route path="/ativar-conta" element={<PublicRoute element={<ActivateAccount />} />} />
            <Route path="/assinar" element={<SubscribeCheckout />} />
            <Route path="/escolher-plano" element={<ChoosePlan />} />
            <Route path="/planos" element={<SelectPlan />} />
            <Route path="*" element={<RouteCatchAll />} />
          </Routes>
        </Suspense>
      </SessionGate>
    </ErrorBoundary>
  </Router>
);

export default RoutesApp;
